import { render, staticRenderFns } from "./UploadServeCheck.vue?vue&type=template&id=1adeb8f9&scoped=true&"
import script from "./UploadServeCheck.vue?vue&type=script&lang=js&"
export * from "./UploadServeCheck.vue?vue&type=script&lang=js&"
import style0 from "./UploadServeCheck.vue?vue&type=style&index=0&id=1adeb8f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adeb8f9",
  null
  
)

export default component.exports